import { Alert, Box, Button, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import MedicineName from './MedicineName'
import Dose from './Dose'
import AdministrationRoute from './AdministrationRoute'
import moment from 'moment'
import Batch from './Batch'
import Expiry from './Expiry'

const ExternalMedicine = ({ submitModule, repeat }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">External Medicine</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <Grid item xs={12}>
          <Alert severity="info" color="warning">
            {repeat
              ? 'This is for recording an additional dose from a medicine already removed from a drugs bag'
              : "This is for recording medicines not inside a tracked medicine bag (i.e. Paramedic's own Morphine, Patient's own Medication)"}
          </Alert>
        </Grid>
        <MedicineName
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Dose moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Batch moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Expiry moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <AdministrationRoute
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Medicine', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ExternalMedicine
